import React, { useState, useEffect } from 'react';
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from '@headlessui/react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';

const Header = ({ activeSection }) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.offsetTop - offset;
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth',
      });
    }
  };

  const navItems = [
    { id: 'home', label: 'Home' },
    { id: 'advantages', label: 'Why Us' },
    { id: 'facilities', label: 'Facilities' },
    { id: 'gallery', label: 'Gallery' },
    { id: 'plans', label: 'Plans' },
    { id: 'rules', label: 'Rules' },
    { id: 'location', label: 'Location' },
    { id: 'contact', label: 'Contact' },
  ];

  return (
    <Disclosure
      as="nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-md'
          : 'bg-white lg:bg-transparent'
        }`}
    >
      <div className="container mx-auto px-2">
        <div className="relative flex items-center justify-between">


          <div className="absolute inset-y-0 left-0 flex items-center lg:hidden">
            <DisclosureButton className="group inline-flex items-center justify-center rounded-md p-2 text-gray-700 hover:bg-gray-100">
              <Bars3Icon className="block h-6 w-6 group-data-open:hidden" />
              <XMarkIcon className="hidden h-6 w-6 group-data-open:block" />
            </DisclosureButton>
          </div>


          <div className="flex flex-1 items-center justify-center lg:justify-start">
            <div
              className="flex shrink-0 items-center cursor-pointer"
              onClick={() => scrollToSection('home')}
            >
              <img
                src="/assets/logo.png"
                alt="Adhyan Study Spaces"
                className="h-24 sm:h-12 lg:h-16 xl:h-40 w-auto object-contain"
              />
            </div>


            <div className="hidden lg:ml-6 lg:flex">
              <div className="flex space-x-2">
                {navItems.map((item) => (
                  <button
                    key={item.id}
                    onClick={() => scrollToSection(item.id)}
                    className={`px-4 py-2 text-base font-medium rounded-md transition ${activeSection === item.id
                        ? 'text-blue-700 bg-blue-50'
                        : 'text-gray-700 hover:text-blue-700 hover:bg-blue-50'
                      }`}
                  >
                    {item.label}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>


      <DisclosurePanel className="lg:hidden bg-white shadow-md">
        {({ close }) => (
          <div className="space-y-1 px-3 pt-2 pb-3">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => {
                  scrollToSection(item.id);
                  close();
                }}
                className={`block w-full text-left rounded-md px-3 py-2 text-base font-medium ${activeSection === item.id
                    ? 'bg-blue-50 text-blue-700'
                    : 'text-gray-700 hover:bg-gray-100'
                  }`}
              >
                {item.label}
              </button>
            ))}
          </div>
        )}
      </DisclosurePanel>
    </Disclosure>
  );
};

export default Header;